import { serverOrderFeeCount } from '@/api/order'
import useWalletStore from '@/lib/store/useWalletStore'
import { Spinner } from '@nextui-org/react'
import { useWeb3ModalAccount } from '@web3modal/ethers/react'
import { useTranslation } from 'react-i18next'
import useSWR from 'swr'

import BG from '@/assets/home/home-add-bottom-bg.png'

export default function HomeAdd() {
	const { t } = useTranslation()
	const { isConnected, address } = useWeb3ModalAccount()

	const isSign = useWalletStore(state => state.isSign)

	const { data, ...args } = useSWR(
		isConnected && !isSign ? ['HomeAdd', address] : ['HomeAdd'],
		async () => {
			const dataParams: any = await serverOrderFeeCount()
			if (dataParams.code === 0) {
				return {
					info: {
						totalFee: dataParams.data.totalFee,
						countAddress: dataParams.data.countAddress,
					},
				}
			}
			return {
				info: {
					totalFee: '0',
					countAddress: '0',
				},
			}
		},
		{
			revalidateIfStale: false,
			revalidateOnFocus: false,
		},
	)

	const loading = args.isLoading || args.isValidating

	return (
		<div className="relative w-full px-2">
			<img
				src={BG}
				alt=""
				className="!w-[calc(100%_+_1rem))] absolute -left-2 top-0 z-0"
				style={{
					maxWidth: 'calc(100% + 1rem)',
				}}
			/>

			<div className="tail-add relative z-10 rounded-2xl border border-white/5 px-5 py-4">
				<div className="w-full text-xl font-semibold text-white">{t('app.fee.title1')}</div>
				{loading ? (
					<div className="flex min-h-[200px] items-center justify-center">
						<Spinner color="white" size="sm" />
					</div>
				) : (
					<div className="flex flex-col gap-4 py-4">
						<div className="flex h-12 items-center justify-between rounded-2xl border border-white/[0.12] bg-white/[0.09] px-5">
							<div className="text-2xl text-white">{data?.info.totalFee}</div>
							<span className="text-base text-[#0083FF]">USDT</span>
						</div>
					</div>
				)}

				<div className="tail-add-card rounded-[0.625rem] px-4 py-2.5">
					<div className="w-full text-lg font-semibold">{t('app.fee.title2')}</div>

					{loading ? (
						<div className="flex min-h-[200px] items-center justify-center">
							<Spinner color="white" size="sm" />
						</div>
					) : (
						<div className="flex flex-col gap-4 pt-5">
							<div className="flex h-12 items-center justify-between rounded-2xl border border-white/[0.12] bg-white/[0.09] px-5">
								<div className="text-2xl text-white">{data?.info.countAddress}</div>
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
	)
}
